import React,{useState} from 'react'
import styled from '@emotion/styled'
import {Link,useHistory} from 'react-router-dom'

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: auto;
    justify-content: space-between;
    align-items: center;
`;
const Wrapper = styled.div`
    width: 33rem;
    height: 23rem;

    background-color: var(--color-gray-100);
    border: 2px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: var(--space-24);
    align-self: center;
    margin-top: 5rem;
    margin-bottom: 5rem;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: auto;
    align-items: center;
`;

const Header = styled.h1`
    font-style: normal;
    font-weight: normal;
    font-size: 13rem;
    line-height: 19rem;
    color: #02B2D9;
`;

const Text = styled.span`
    font-family: Inter,sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-28);
    line-height: var(--font-32);
    color: var(--color-gray-500);
    text-align: center;
`;

const ReturnLink = styled.a`
    padding-top: 1rem;
    font-family: Inter,sans-serif;
    font-size: var(--font-28);
    line-height: var(--space-32);
    color: var(--company-dark);
    text-decoration: underline;
    cursor: pointer;
`;
const NotFound = () => {
    let history = useHistory();
    let location = (history.location.pathname).slice(1);

    return (
        <MainContainer>
            <Wrapper>
                <Container>
                    <Header>404</Header>
                    <Text>Resource Not Found</Text>
                </Container>
            </Wrapper>
            <ReturnLink onClick={()=>history.goBack()}>{"Return to "+location}</ReturnLink>
        </MainContainer>
    )
}

export default NotFound;
